import React, { useEffect, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import "../../style/components/IngredientParallax.css";
import LazyImage from "../generics/LazyImage";
import { useMediaQuery } from "@mui/material";
import { breakpoint, DESIGN_WIDTH_MOBILE, DESIGN_WIDTH_DESKTOP } from "../../utils/responsiveUtils";

export const calcPosition = (image, imageMode, originalWidth, windowWidth) => {
  const mode = image[imageMode];
  if (!mode) return { width: 0, left: 0, top: 0 };
  return {
    width: (mode.size.width / originalWidth) * windowWidth,
    left: (mode.position.left / originalWidth) * windowWidth,
    top: (mode.position.top / originalWidth) * windowWidth,
  };
};

function IngredientImages({ target, images, handleOpenSlide }) {
  const mobile = useMediaQuery(breakpoint.mobileSm);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const originalWidth = mobile ? DESIGN_WIDTH_MOBILE : DESIGN_WIDTH_DESKTOP;
  const imageMode = mobile ? "mobile" : "default";

  const { scrollYProgress } = useScroll({
    target,
    offset: ["start end", "end start"],
  });
  const layer1 = useTransform(scrollYProgress, [0, 1], [0, mobile ? 70 : 200]);
  const layer2 = useTransform(
    scrollYProgress,
    [0, 1],
    [0, mobile ? -70 : -100]
  );

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const position = (image) => calcPosition(image, imageMode, originalWidth, windowWidth);

  return (
    <motion.div className="home-ingredient-image">
      {images.map((image, index) => (
        <motion.div
          key={image.title}
          className={`clickable ${index % 2 === 0 ? "layer01" : "layer02"}`}
          loading="lazy"
          style={{
            ...position(image),
            y: index % 2 === 0 ? layer1 : layer2,
          }}
          onClick={() => handleOpenSlide(index)}
        >
          <LazyImage imageSrc={image.image} alt={image.title} />
        </motion.div>
      ))}
    </motion.div>
  );
}

export default IngredientImages;
